// removed by extract-text-webpack-plugin
module.exports = {"my-setting-wrapper":"index__my-setting-wrapper___qGEre","avatar-wrapper":"index__avatar-wrapper___NDPFj","changepwd-wrapper":"index__changepwd-wrapper___2TZMf","avatar-img-wrapper":"index__avatar-img-wrapper___3VaTg","avatar-img":"index__avatar-img___1l5Q7","avatar-text-email":"index__avatar-text-email___1cjh_","mySetting-panel-content":"index__mySetting-panel-content___2aCHB"};


//////////////////
// WEBPACK FOOTER
// ./src/views/MySetting/index.less
// module id = 303
// module chunks = 3